import { z } from "zod"
import {
  branchIdSchema,
  correlationIdSchema,
  entityIdSchema,
  legalEntityIdSchema,
  tenantIdSchema,
} from "./identifiers.js"

const reason = z.string().trim().min(1).max(500)
const base = z.object({
  requestVersion: z.literal(1),
  correlationId: correlationIdSchema,
  idempotencyKey: z.string().regex(/^[A-Za-z0-9][A-Za-z0-9._:-]{0,127}$/),
  expectedVersion: z.number().int().nonnegative(),
}).strict()

export const branchOperatingModeRequestV1Schema = base.extend({
  policyId: tenantIdSchema,
  operatingMode: z.enum(["centralized", "separately_managed"]),
  modeRevisionId: entityIdSchema,
  reason,
}).strict()

export const customerBranchGrantAccessV1Schema = z.object({
  operationalAccess: z.boolean(),
  billingAccess: z.boolean(),
}).strict().refine((value) => value.operationalAccess || value.billingAccess, {
  message: "At least one access kind is required.",
})

export const customerBranchGrantRequestV1Schema = base.extend({
  grantId: entityIdSchema,
  customerId: entityIdSchema,
  branchId: branchIdSchema,
  legalEntityId: legalEntityIdSchema,
  access: customerBranchGrantAccessV1Schema,
  reason,
}).strict()

export const customerBranchGrantDecisionV1Schema = base.extend({
  grantId: entityIdSchema,
  owningBranchId: branchIdSchema,
  owningLegalEntityId: legalEntityIdSchema,
  decision: z.enum(["approve", "reject", "revoke"]),
  reason,
}).strict()

export type BranchOperatingModeRequestV1 = z.infer<typeof branchOperatingModeRequestV1Schema>
export type CustomerBranchGrantRequestV1 = z.infer<typeof customerBranchGrantRequestV1Schema>
export type CustomerBranchGrantDecisionV1 = z.infer<typeof customerBranchGrantDecisionV1Schema>
